export default "__VITE_ASSET__7TiwvFfA__"